// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myAccountViewStyles } from "@pace/Overrides/Widgets/MyAccount/MyAccountView";
import { DivWrapper } from "@pace/XDL/constants";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

myAccountViewStyles.pageWrapper = {
    css: css`
        display: flex;
        gap: 22px;
        ${xScreen("lt", "sm")} {
            justify-content: center;
            flex-direction: column;
        }
    `,
};
myAccountViewStyles.quickLinksGridItem = {
    css: css`
        flex: 0 0 317px;
        ${xScreen("lte", "sm")} {
            justify-content: center;
            flex: 0 0 358px;
        }
        ${xScreen("lte", "xs")} {
            flex-basis: 100%;
        }
    `,
};
myAccountViewStyles.mainSectionGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: hidden;
    `,
};

myAccountViewStyles.myAccountHeaderGridItem = {
    width: 12,
    css: css`
        > ${DivWrapper} {
            display: flex;
            align-items: baseline;
            flex-wrap: wrap;
            justify-content: space-between;
            gap: 12px;
            [data-test-selector="PageTitle"] {
                margin: 0;
            }
        }
        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 20px;
        margin-bottom: 20px;
    `,
};
